import Switch from '@components/v2/form/Switch/Switch';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { PublicShowroomSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const PublicShowroomSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: PublicShowroomSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GENERAL_SETTINGS_PUBLIC_SHOWROOM_TITLE)}
      description={LangEnum.GENERAL_SETTINGS_PUBLIC_SHOWROOM_DESCRIPTION}
    >
      <Switch
        label={translate(LangEnum.GENERAL_SETTINGS_PUBLIC_SHOWROOM_SWITCH_LABEL)}
        name="enablePublicShowroom"
        size="medium"
        sx={{ ml: 0 }}
        checked={generalSettings.enablePublicShowroom}
        onChange={(_, checked) =>
          handleChangeAndBlur({ value: checked, name: 'enablePublicShowroom' })
        }
      />
    </SettingContainer>
  );
};

export default PublicShowroomSectionGeneralSettings;
